export default __webpack_public_path__ + "static/img/molla.a28aa2c.jpg";